/**
 * preview gallery
 */

declare var Splide: any;

const previewGallery = () => {
  const galleries = document.querySelectorAll('.js-preview-gallery');

  if (galleries.length > 0) {
    galleries.forEach(elementGallery => {
      let galleryImages = elementGallery.querySelectorAll('.js-preview-item');
      let preview = elementGallery.querySelector('.js-preview-popup');
      let previewSlider = elementGallery.querySelector('.js-preview-splide');

      if (galleryImages.length > 0 && preview && previewSlider) {
        const previewSplide = new Splide( previewSlider, {
          type: 'loop',
          pagination: false,
          perPage: 1,
          gap: 100,
          lazyLoad: 'nearby',
          focus: 'center',
          autoWidth: true,
        });
        previewSplide.mount();

        galleryImages.forEach((elementImages, key) => {
          elementImages.addEventListener('click', function () {
            previewSplide.go(key);
            preview?.classList.add('active');
            document.body.style.overflow = 'hidden';
          });
        });

        let closeBtn = preview.querySelector('.js-preview-close');
        closeBtn?.addEventListener('click', function () {
          preview?.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
    });
  }
};

export default previewGallery;